(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/svsuid/assets/javascripts/svsuid.js') >= 0) return;  svs.modules.push('/components/utils/svsuid/assets/javascripts/svsuid.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var randomBytes = function randomBytes(length) {
  var randomBytesString = new Uint8Array(length);
  for (var i = 0; i < length; i++) {
    randomBytesString[i] = Math.floor(Math.random() * 256);
  }
  return randomBytesString;
};
var getRandomItem = function getRandomItem(charsArray) {
  var randomIndex = Math.floor(Math.random() * charsArray.length);
  return charsArray[randomIndex];
};

var svsuid = function svsuid() {
  var uuidArray = _toConsumableArray(randomBytes(16)).map(function (byte) {
    return byte.toString(16).padStart(2, '0');
  });

  uuidArray[6] = "4".concat(uuidArray[6][1]);
  uuidArray[8] = "".concat(getRandomItem(['8', '9', 'a', 'b'])).concat(uuidArray[8][1]);

  var uuid = uuidArray.join('');

  return "".concat(uuid.slice(0, 8), "-").concat(uuid.slice(8, 12), "-").concat(uuid.slice(12, 16), "-") + "".concat(uuid.slice(16, 20), "-").concat(uuid.slice(20));
};

svs.utils = _objectSpread(_objectSpread({}, svs.utils), {}, {
  svsuid: svsuid
}) || {
  svsuid: svsuid
};

if (svs.isServer) {
  module.exports = svs.utils.svsuid;
}

 })(window);